// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { setSearchInput, getSearchData } from 'actions/search'

class SearchBar extends React.Component {
	componentDidUpdate( prevProps, prevState ) {
		if ( this.props.searchIsOpen && ! prevProps.searchIsOpen && 'Our Entities' != this.props.searchTerm && 'Churches Near Me' != this.props.searchTerm ) {
			this.searchInput.focus()
		}
	}

	handleChange = ( e ) => {
		const { dispatch } = this.props

		dispatch( setSearchInput( e.target.value ) )
	}

	handleSubmit = ( e ) => {
		const { dispatch, searchTerm } = this.props

		dispatch( getSearchData( searchTerm ) )

		if ( window.innerWidth <= siteData.mobile_max_width ) {
			this.searchInput.blur()
		}

		window.scrollTo( 0, 0 )

		e.preventDefault()
	}

	handleKeyDown = ( e ) => {
		const { dispatch, searchTerm } = this.props

		let isEscape = false,
			isSpace = false

		if ( 'key' in e ) {
			isEscape = ( e.key == 'Escape' || e.key == 'Esc' )
			isSpace = ( e.key == 'Space' || e.key == ' ' )
		} else {
			isEscape = ( e.keyCode == 27 )
			isSpace = ( e.keyCode == 32 )
		}

		if ( isSpace ) {
			dispatch( getSearchData( searchTerm ) )
		}
	}

	render() {
		const { searchTerm } = this.props

		return (
			<div className="search-bar">
				<form className="-form" action="" method="get" onSubmit={ this.handleSubmit }>
					<div className="-input">
						<input type="text"
							ref={ ( e ) => { this.searchInput = e } }
							value={ searchTerm }
							onChange={ this.handleChange }
							onKeyDown={ this.handleKeyDown }
							className="large"
							placeholder="Search..." />
					</div>

					<div className="-button" onClick={ this.handleSubmit }>
						<i className="icon-search" aria-hidden="true"></i>
					</div>
				</form>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		searchIsOpen: state.search.isOpen,
		searchTerm: state.search.searchTerm
	}
}

export default connect( mapStateToProps )( SearchBar )
